// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__C7RjY","icon":"SortAdornment_icon__2jXYy","up":"SortAdornment_up__3nt9J","down":"SortAdornment_down__3PtrV","active":"SortAdornment_active__2IFuV"};